/* Studio VormVezel – zoekpaneel op dezelfde pagina (sections/vv-predictive-search.liquid). Geen afhankelijkheden.
   Werkt samen met assets/vv.js: window.vv.openPanel / closeTop (stapel, grijze achtergrond, focusval, #site inert,
   zwevende app-knoppen verbergen) en het event 'vv:close' dat vv.js op een paneel afvuurt als het sluit.

   - Openen: elke [data-vv-search-open] (vergrootglas in de kop, zoekknop in het mobiele menu) en, alleen als de eigenaar
     de sneltoets aanzet (standaard uit), de toets '/' (computer).
     Zonder JavaScript blijft de link naar /search werken. De focus gaat in dezelfde klik naar het zoekveld (iPhone: dan
     gaat het toetsenbord meteen open).
   - Sluiten: Esc, Sluiten/Annuleer, klik op de achtergrond of de terugknop (history.pushState bij openen).
     Sluiten zonder een resultaat te kiezen maakt het veld leeg (computer en telefoon gelijk): opnieuw openen toont het lege paneel.
   - Typen: vanaf 2 tekens, 200 ms na de laatste toets, haalt de sectie op via de Section Rendering API
     (/search/suggest?…&section_id=vv-predictive-search); oude verzoeken worden afgebroken, antwoorden onthouden.
   - Toetsenbord: zoekveld als combobox (pijltjes kiezen een suggestie, Enter opent hem; zonder keuze naar de zoekpagina).
     Het aantal suggesties wordt voorgelezen via #vv-live. */
(function () {
  'use strict';
  if (window.vvSearch) return;
  var D = document, W = window;
  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  var DESIGN = !!(W.Shopify && W.Shopify.designMode);
  var mqDesk = W.matchMedia ? W.matchMedia('(min-width: 1024px)') : null;

  var panel = null, input = null, box = null, empty = null, body = null, clearBtn = null, form = null;
  var cfg = {}, timer = null, ctrl = null, reqId = 0, loadTimer = null, cache = {}, active = -1, shown = '';
  var pushed = false, popping = false, leaving = false, editing = false;

  function vv() { return W.vv || null; }
  function isOpen() { return !!(panel && panel.classList.contains('open')); }
  function tok(s, map) { s = String(s || ''); for (var k in map) { if (map.hasOwnProperty(k)) s = s.split('[' + k + ']').join(map[k]); } return s; }
  function esc(x) { return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function visible(el) { return !!(el && el.getClientRects().length); }
  function focusNow(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }

  /* ---------- Paneel opzoeken en koppelen (ook opnieuw na herladen in de thema-editor) ---------- */
  function init() {
    var p = D.getElementById('search');
    if (!p || !p.hasAttribute('data-vvs-panel')) { panel = null; return false; }
    if (p === panel && p._vvs) return true;
    panel = p; panel._vvs = true;
    input = $('[data-vvs-input]', panel); box = $('[data-vvs-box]', panel); empty = $('[data-vvs-empty]', panel);
    body = $('[data-vvs-body]', panel); clearBtn = $('[data-vvs-clear]', panel); form = $('[data-vvs-form]', panel);
    cfg = {
      url: panel.getAttribute('data-url') || '/search/suggest',
      sid: panel.getAttribute('data-section') || 'vv-predictive-search',
      limit: Math.max(1, Math.min(10, parseInt(panel.getAttribute('data-limit'), 10) || 6)),
      phDesk: panel.getAttribute('data-ph-desk') || '', phMob: panel.getAttribute('data-ph-mob') || '',
      srResults: panel.getAttribute('data-sr-results') || '', srNone: panel.getAttribute('data-sr-none') || '',
      error: panel.getAttribute('data-error') || ''
    };
    cache = {}; active = -1; shown = '';
    setPlaceholder();
    if (!input || !box) return false;
    input.addEventListener('input', onInput);
    input.addEventListener('keydown', onKey);
    if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; onInput(); focusNow(input); });
    if (form) form.addEventListener('submit', onSubmit);
    panel.addEventListener('click', onPanelClick);
    panel.addEventListener('vv:close', onClosed);
    return true;
  }
  function setPlaceholder() {
    if (!input) return;
    var desk = mqDesk ? mqDesk.matches : true;
    var ph = desk ? cfg.phDesk : (cfg.phMob || cfg.phDesk);
    if (ph) input.setAttribute('placeholder', ph);
  }
  if (mqDesk) { var onMq = function () { setPlaceholder(); if (isOpen()) setTop(); }; if (mqDesk.addEventListener) mqDesk.addEventListener('change', onMq); else if (mqDesk.addListener) mqDesk.addListener(onMq); }

  /* Op de computer opent het paneel direct onder de kop; de grijze achtergrond begint daar ook (#layers.vvs-on) */
  function setTop() {
    var layers = D.getElementById('layers'); if (!layers) return;
    var hdr = $('.hdr'), top = 0;
    if (hdr) { var r = hdr.getBoundingClientRect(); top = Math.max(0, Math.round(r.bottom)); }
    layers.style.setProperty('--vvs-top', top + 'px');
  }
  W.addEventListener('resize', function () { if (isOpen()) setTop(); }, { passive: true });

  /* ---------- Openen en sluiten ---------- */
  function open(opener) {
    if (!init()) return false;
    var v = vv(); if (!v || !v.openPanel) return false;
    if (isOpen()) { focusNow(input); return true; }
    /* Vanuit het mobiele menu: eerst het menu sluiten (zonder focus terug), dan het zoekpaneel; focus terug gaat naar de menuknop */
    var menu = D.getElementById('menu');
    if (menu && menu.classList.contains('open') && v.top && v.top() === menu) { v.closeTop(true); opener = $('[data-open="menu"]') || opener; }
    if (panel.parentNode && panel.parentNode.id !== 'layers') { var layers = D.getElementById('layers'); if (layers) layers.appendChild(panel); }
    setTop();
    var layersEl = D.getElementById('layers'); if (layersEl) layersEl.classList.add('vvs-on');
    syncTriggers(true);
    v.openPanel(panel, opener && opener.nodeType === 1 ? opener : D.activeElement);
    focusNow(input); /* in dezelfde klik: iPhone opent dan het toetsenbord */
    if (input.value) { try { input.select(); } catch (e) {} }
    if (!DESIGN && !pushed && W.history && history.pushState) {
      try { history.pushState({ vvSearch: 1 }, ''); pushed = true; } catch (e) {}
    }
    return true;
  }
  function close() { var v = vv(); if (isOpen() && v && v.top && v.top() === panel) v.closeTop(); }
  function onClosed() {
    var layers = D.getElementById('layers');
    if (layers) setTimeout(function () { if (!isOpen()) layers.classList.remove('vvs-on'); }, 230);
    syncTriggers(false);
    setActive(-1);
    /* Gesloten zonder een resultaat te kiezen: veld leeg, volgende keer het lege paneel (Veel gezocht, Shop per model) */
    if (!leaving && !editing) resetField();
    if (pushed && !popping && !leaving) { pushed = false; try { history.back(); } catch (e) {} }
    else if (popping) pushed = false;
  }
  function resetField() {
    if (!input) return;
    clearTimeout(timer); abort();
    input.value = '';
    if (clearBtn) clearBtn.hidden = true;
    showEmpty();
  }
  function syncTriggers(on) { $$('[data-vv-search-open][aria-expanded]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); }); }
  W.addEventListener('popstate', function () {
    if (isOpen() && !(history.state && history.state.vvSearch)) { popping = true; close(); popping = false; pushed = false; }
  });
  /* Na herladen of terugkomen staat de extra geschiedenisstap niet meer open */
  try { if (history.state && history.state.vvSearch) history.replaceState(null, ''); } catch (e) {}
  W.addEventListener('pageshow', function (e) { if (e.persisted && isOpen()) { leaving = true; close(); leaving = false; } pushed = false; });

  /* Naar een andere pagina vanuit het paneel: de extra geschiedenisstap vervangen, zodat 'terug' meteen de vorige pagina is */
  function go(href) {
    if (!href) return;
    leaving = true;
    if (pushed) { pushed = false; try { location.replace(href); return; } catch (e) {} }
    location.href = href;
  }

  /* ---------- Typen en ophalen ---------- */
  function onInput() {
    var q = input.value.replace(/\s+/g, ' ').trim();
    if (clearBtn) clearBtn.hidden = !input.value;
    clearTimeout(timer);
    if (q.length < 2) { abort(); showEmpty(); return; }
    timer = setTimeout(function () { load(q); }, 200);
  }
  function abort() { if (ctrl) { try { ctrl.abort(); } catch (e) {} ctrl = null; } clearTimeout(loadTimer); setBusy(false); }
  function setBusy(on) { if (!panel) return; panel.classList.toggle('vvs-busy', !!on); if (box) { if (on) box.setAttribute('aria-busy', 'true'); else box.removeAttribute('aria-busy'); } }
  function suggestUrl(q) {
    return cfg.url + (cfg.url.indexOf('?') > -1 ? '&' : '?') + 'q=' + encodeURIComponent(q) +
      '&resources%5Btype%5D=product%2Ccollection%2Cpage%2Cquery&resources%5Blimit%5D=' + cfg.limit +
      '&resources%5Blimit_scope%5D=each&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
      '&section_id=' + encodeURIComponent(cfg.sid);
  }
  function load(q) {
    var key = q.toLowerCase();
    if (cache[key]) { render(cache[key], q); return; }
    abort();
    var id = ++reqId;
    ctrl = W.AbortController ? new AbortController() : null;
    /* pas na 300 ms een rustige 'bezig'-staat, zodat snelle antwoorden niet knipperen */
    loadTimer = setTimeout(function () { if (id === reqId) { setBusy(true); if (box.hidden) skeleton(); } }, 300);
    fetch(suggestUrl(q), { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('status ' + r.status); return r.text(); })
      .then(function (html) {
        var tmp = D.createElement('div'); tmp.innerHTML = html;
        var res = tmp.querySelector('[data-vvs-results]'); if (!res) throw new Error('geen resultaten');
        var data = { html: res.outerHTML, card: res.getAttribute('data-card') || '', total: parseInt(res.getAttribute('data-total'), 10) || 0 };
        cache[key] = data;
        if (id === reqId && current() === key) render(data, q);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (id === reqId && current() === key) renderError(q);
      })
      .then(function () { if (id === reqId) { clearTimeout(loadTimer); setBusy(false); ctrl = null; } });
  }
  function current() { return input ? input.value.replace(/\s+/g, ' ').trim().toLowerCase() : ''; }
  function skeleton() {
    box.innerHTML = '<div class="vvs-skel" aria-hidden="true"><i></i><i></i><i></i><i></i></div>';
    box.hidden = false; if (empty) empty.hidden = true;
  }
  function render(data, q) {
    box.innerHTML = data.html; box.hidden = false; if (empty) empty.hidden = true;
    shown = q.toLowerCase(); setActive(-1);
    var n = options().length;
    input.setAttribute('aria-expanded', n ? 'true' : 'false');
    if (body) body.scrollTop = 0;
    var v = vv(), msg = '';
    if (data.card) msg = data.card + '. ';
    msg += n ? tok(cfg.srResults, { aantal: n, zoekterm: q }) : tok(cfg.srNone, { zoekterm: q });
    if (v && v.announce) v.announce(msg.trim());
  }
  function renderError(q) {
    box.innerHTML = '<p class="vvs-err">' + esc(cfg.error) + '</p>';
    box.hidden = false; if (empty) empty.hidden = true;
    input.setAttribute('aria-expanded', 'false'); setActive(-1); shown = '';
    var v = vv(); if (v && v.announce && cfg.error) v.announce(cfg.error);
  }
  function showEmpty() {
    if (!box) return;
    box.hidden = true; box.innerHTML = ''; shown = '';
    if (empty) empty.hidden = false;
    input.setAttribute('aria-expanded', 'false'); setActive(-1);
  }
  /* Een zoekwoord kiezen: in het veld zetten en meteen zoeken (je blijft in het paneel) */
  function pick(word) {
    input.value = word; if (clearBtn) clearBtn.hidden = !word;
    clearTimeout(timer); focusNow(input);
    try { var l = input.value.length; input.setSelectionRange(l, l); } catch (e) {}
    if (word.trim().length >= 2) load(word.replace(/\s+/g, ' ').trim()); else showEmpty();
  }

  /* ---------- Combobox: pijltjes, Enter ---------- */
  function options() { return box && !box.hidden ? $$('[role="option"]', box).filter(visible) : []; }
  function setActive(i) {
    var opts = options();
    $$('[role="option"][aria-selected="true"]', box || panel || D).forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
    active = (i >= 0 && i < opts.length) ? i : -1;
    if (!input) return;
    if (active < 0) { input.removeAttribute('aria-activedescendant'); return; }
    var o = opts[active]; o.setAttribute('aria-selected', 'true');
    input.setAttribute('aria-activedescendant', o.id);
    try { o.scrollIntoView({ block: 'nearest' }); } catch (e) {}
  }
  function onKey(e) {
    if (e.isComposing) return;
    var opts = options();
    if (e.key === 'ArrowDown') {
      if (!opts.length) return;
      e.preventDefault(); setActive(active + 1 >= opts.length ? 0 : active + 1);
    } else if (e.key === 'ArrowUp') {
      if (!opts.length) return;
      e.preventDefault(); setActive(active <= 0 ? (active === 0 ? -1 : opts.length - 1) : active - 1);
    } else if (e.key === 'Enter') {
      if (active >= 0 && opts[active]) { e.preventDefault(); activate(opts[active]); }
    } else if (e.key === 'Escape' && active >= 0) {
      /* eerst de keuze opheffen; nog een keer Esc sluit het paneel */
      e.preventDefault(); e.stopPropagation(); setActive(-1);
    }
  }
  function activate(a) {
    var w = a.getAttribute('data-vvs-q');
    if (w != null && w.trim().toLowerCase() !== shown) { pick(w); return; }
    go(a.getAttribute('href'));
  }
  function onPanelClick(e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]'); if (!a || !panel.contains(a)) return;
    var w = a.getAttribute('data-vvs-q');
    if (w != null && w.trim().toLowerCase() !== shown) { e.preventDefault(); pick(w); return; }
    if (a.target && a.target !== '_self') return;
    var href = a.getAttribute('href') || '';
    if (/^(tel:|mailto:|#)/i.test(href)) return;
    if (a.host && a.host !== location.host) return;
    e.preventDefault(); go(a.href);
  }
  function onSubmit(e) {
    e.preventDefault();
    var q = input.value.replace(/\s+/g, ' ').trim();
    if (!q) { focusNow(input); return; }
    var opts = options(); if (active >= 0 && opts[active]) { activate(opts[active]); return; }
    var params = [];
    $$('input[name]', form).forEach(function (i) { if (i.name) params.push(encodeURIComponent(i.name) + '=' + encodeURIComponent(i.name === 'q' ? q : i.value)); });
    go(form.getAttribute('action') + '?' + params.join('&'));
  }

  /* ---------- Openen: klik, sneltoets '/', alvast fotootjes laden bij aanwijzen ---------- */
  D.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-vv-search-open]'); if (!t) return;
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (open(t)) e.preventDefault();
  });
  function typing(el) {
    if (!el) return false;
    var tg = el.tagName;
    return el.isContentEditable || tg === 'INPUT' || tg === 'TEXTAREA' || tg === 'SELECT';
  }
  D.addEventListener('keydown', function (e) {
    if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey || e.defaultPrevented || typing(e.target)) return;
    if (!init() || !panel.hasAttribute('data-shortcut') || D.documentElement.classList.contains('vv-modal-open')) return;
    var t = $('.hdr [data-vv-search-open]'); if (!t || !visible(t)) return;
    e.preventDefault(); open(t);
  });
  function warm(e) {
    var t = e.target.closest && e.target.closest('[data-vv-search-open]'); if (!t || !init()) return;
    $$('img[data-vv-src]', panel).forEach(function (im) {
      var ss = im.getAttribute('data-vv-srcset'); if (ss) { im.setAttribute('srcset', ss); im.removeAttribute('data-vv-srcset'); }
      im.setAttribute('src', im.getAttribute('data-vv-src')); im.removeAttribute('data-vv-src');
    });
  }
  D.addEventListener('mouseover', warm, { passive: true });
  D.addEventListener('focusin', warm);

  /* ---------- Thema-editor: paneel open zolang de sectie 'VV Zoekpaneel' of een blok ervan geselecteerd is ---------- */
  function mine(e) { return !!(e.detail && cfg && (e.detail.sectionId === (cfg.sid || 'vv-predictive-search') || e.detail.sectionId === 'vv-predictive-search')); }
  D.addEventListener('shopify:section:select', function (e) { if (!mine(e)) return; editing = true; open(null); });
  D.addEventListener('shopify:block:select', function (e) {
    if (!mine(e)) return; editing = true; open(null);
    var el = e.target; if (el && el.scrollIntoView) { try { el.scrollIntoView({ block: 'nearest' }); } catch (x) {} }
  });
  D.addEventListener('shopify:section:deselect', function (e) { if (!mine(e)) return; editing = false; close(); });
  D.addEventListener('shopify:section:load', function (e) {
    if (!mine(e)) return;
    /* vv.js heeft het nieuwe paneel al naar #layers verplaatst */
    panel = null; init();
    if (editing) open(null);
  });

  init();
  W.vvSearch = { open: open, close: close, isOpen: isOpen };
})();
